import Label from "core/label/Label";
import _ from "lodash";
import {
  CONSULTANT_MISSION_STATUS,
  ED_STATUS_LABEL,
  STATUS_MISSION,
} from "constants/constants";
import { getMissionStatusColor } from "./consultantHelper";

export const getStatusLabel = (status) => {
  const statusLabels = {
    [STATUS_MISSION.OK]: "OK",
    [STATUS_MISSION.ONE]: "1",
    [STATUS_MISSION.ZERO]: "0",
    [STATUS_MISSION.FDM]: "FDM",
    [STATUS_MISSION.IC]: "IC",
    [STATUS_MISSION.ED]: ED_STATUS_LABEL,
    [CONSULTANT_MISSION_STATUS.STATUS_ED]: ED_STATUS_LABEL,
    [STATUS_MISSION.HD]: "HD",
    [STATUS_MISSION.CL]: "CL",
    [STATUS_MISSION.BACKUP]: "BACKUP",
  };
  return (
    <Label
      id={status}
      className="small"
      color={getMissionStatusColor(status) || "pink-lady"}
      label={
        statusLabels[status] || status?.replace("status_", "")?.toUpperCase()
      }
    />
  );
};

export const getCurrentManager = (list) =>
  _.chain(list)
    .filter(
      (elm) => new Date(elm.establishment_date).getTime() < new Date().getTime()
    )
    .sort(
      (a, b) => new Date(b.establishment_date) - new Date(a.establishment_date)
    )
    .first()
    .get("manager_id")
    .toNumber()
    .value();

export const getJobLabel = (list, jobId, lang) => {
  const job = _.find(list, { id: jobId });
  return lang === "fr" ? job?.fr : job?.en;
};
